import React from "react";
import { BrowserRouter } from "react-router-dom";
import store from "../../reducers/store";
import { Provider } from "react-redux";
import ThemedApp from "./ThemedApp";
import DataLoader from "./DataLoader";

export const APP_VERSION = "1.0.0";

// Update this to force a cache clear
export const PRODUCTS_VARIATIONS_CACHE_KEY = "936f1222-e200-47ae-af09-66eb65d80307";

const App = () => (
  <Provider store={store}>
    <DataLoader />
    <BrowserRouter>
      <ThemedApp />
    </BrowserRouter>
  </Provider>
)

export default App;
